import { Button } from '@customerio/pluma-components/react';
import { useOpenSegmentsAddon } from '../hooks/use-open-segments-addon';
import { FlexMark } from './flex-mark';
import * as styles from './segments-addon-button.css';

type SegmentsAddonButtonProps = {
  /** Inside a caution banner: a plain secondary button with the mark in the banner's colours. */
  tone?: 'caution';
};

/**
 * The Credits Lifecycle prototype's "Flex add-on" tag, offered at the data-driven segment cap. It is a small Pluma
 * Button because Pluma's Badge and Tag are not actions.
 */
export function SegmentsAddonButton({ tone }: SegmentsAddonButtonProps) {
  const openSegmentsAddon = useOpenSegmentsAddon();
  const isCaution = tone === 'caution';

  return (
    <Button
      className={isCaution ? undefined : styles.flexTag}
      variant={isCaution ? 'secondary' : undefined}
      size="sm"
      elementBefore={<FlexMark tone={tone} />}
      onClick={() => void openSegmentsAddon()}
    >
      Flex add-on
    </Button>
  );
}
